import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppComponent } from 'src/app/app.component';
import { UtilsService } from 'src/app/services/utils.service';
import { crossMsg, drOption } from '@robisoft/cross-library';
import { AppSettings } from 'src/app/app.settings';
import { RecaptchaComponent } from 'ng-recaptcha';
import { CrossCpService } from 'src/app/cross-utils/services/cross-cp.service';
import { SendFormReq } from 'src/app/models/SendForm';
import { PrivacyComponent } from 'src/app/cross-utils/privacy/privacy.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-tornei-golf',
  templateUrl: './tornei-golf.component.html',
  styleUrls: ['./tornei-golf.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class TorneiGolfComponent implements OnInit, OnDestroy {
  store: string;

  prenotaNome: string;
  prenotaEmail: string;
  prenotaMobile: string;
  prenotaTorneo: string;
  prenotaMsg: string;
  privacy: boolean;
  errorMessage: string;

  captcha: string;
  @ViewChild('recaptcha') captchaElem: RecaptchaComponent;
  sub: Subscription;
  firstRun: boolean;

  constructor(public app: AppComponent,
    private cpService: CrossCpService,
    private dialog: MatDialog,
    public utils: UtilsService) {

    this.prenotaNome = '';
    this.prenotaEmail = '';
    this.prenotaMobile = '';
    this.prenotaTorneo = '';
    this.prenotaMsg = '';
    this.privacy = false;
    this.errorMessage = '';
    this.captcha = '';
    this.sub = new Subscription();
    this.firstRun = false;
  }

  ngOnInit(): void {
    this.sub = this.app.initialized.subscribe(async (init) => {
      if (init && !this.firstRun) {
      }
    });
  }

  ngOnDestroy(): void {

  }

  resolved(captchaResponse: string) {
    this.captcha = captchaResponse;
    this.checkForm();
  }

  async invia() {
    this.errorMessage = '';
    this.checkForm();

    if (this.errorMessage === '') {
      const req = new SendFormReq();
      req.store = this.store;
      req.responseCaptcha = this.captcha;
      req.emailModel = 'tornei-golf';
      req.emailModel2 = 'richiesta-inoltrata';
      req.lang = 'it';
      req.fields = [];
      req.fields.push(new drOption(this.prenotaNome, 'Nome Cognome'));
      req.fields.push(new drOption(this.prenotaEmail, 'Email'));
      req.fields.push(new drOption(this.prenotaMobile, 'Cellulare'));
      req.fields.push(new drOption(this.prenotaTorneo, 'Nome del Torneo'));
      req.fields.push(new drOption(this.prenotaMsg, 'Messaggio'));
      const resp = await this.cpService.sendForm(AppSettings.API_ENDPOINT, req);
      if (resp.error === '') {
        this.prenotaNome = '';
        this.prenotaEmail = '';
        this.prenotaMobile = '';
        this.prenotaTorneo = '';
        this.prenotaMsg = '';
        this.privacy = false;
        this.errorMessage = '';
        this.captcha = '';
        this.captchaElem.reset();
        this.app.onMessage.emit(new crossMsg('showToastMessage', {
          message: 'Messaggio inviato con successo',
        }));
      }

    }
  }
  public gotoLogin(): void {
    this.app.onMessage.emit(new crossMsg('gotoLogin', {
      store: this.app.store,
    })
    );
  }

  public checkForm() {
    if (this.prenotaNome === '')
      this.errorMessage = 'Inserisci il tuo nome';
    else if (this.prenotaTorneo === '')
      this.errorMessage = 'Inserisci il nome del torneo';
    else if (this.prenotaEmail === '')
      this.errorMessage = 'Inserisci la tua email';
    else if (this.prenotaMobile === '')
      this.errorMessage = 'Inserisci il tuo numero di cellulare';
    else if (this.privacy === false)
      this.errorMessage = 'Devi accettare le condizioni';
    else if (this.captcha === '')
      this.errorMessage = 'Spunta il re-captcha';
    else
      this.errorMessage = '';
  }

  openUrl(url: string) {
    let link = '';
    if (!url) {
      url = 'https://opengolf.it/it/privacy-policy?header=no';
    }
    if (url.startsWith('http'))
      link = url;
    else
      link = AppSettings.URL + '/img/' + this.app.store + '/' + url;

    const dialogRef = this.dialog.open(PrivacyComponent, {
      data: {
        privacyUrl: link
      },
      panelClass: 'full-screen'
    });

  }


}
